<template>
  <div id="chart">
    <apexchart type="area" height="200" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>
<script>
  import VueApexCharts from 'vue-apexcharts'
  export default {
    name: "UsersNumber",
    props: ['getseries'],
    components: {
      apexchart: VueApexCharts,
    },
    data() {
      return {

        series: [{
            name: "مستخدم",
            data: this.getseries
        }],

        chartOptions: {
          chart: {
            height: 200,
            type: 'line',
            toolbar: {
              show: false
            },
            zoom: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            curve: 'straight',
            width: 5,
            dashArray: 0,
          },
          grid: {
            column: {
              colors: ['#F2F2FA', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
            xaxis: {
              lines: {
                show: false
              }
            },
            yaxis: {
                lines: {
                    show: false
                }
            },
          },
          xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
            labels: {
                style: {
                    colors: '#8392A5',
                },
            },
          },
          yaxis: {
            labels: {
                show: true,
                align: 'center',
                style: {colors: '#8392A5'},
            },
          },
          tooltip: {
              marker: {
                  show: false,
              },
          }
        },

      }
    },
    created() {
      console.log(this.getseries);
    },
  }
</script>

<style lang="scss" scoped>

</style>
